import { ViewModel, View } from "binder"
import moment from "moment";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class WorkingShiftSelectorViewModel extends SelectorBaseViewModel<WorkingShift> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    protected async loadData(): Promise<WorkingShift[]> {
        let result = await ServerConnection.callServer('/Complex/WorkingShiftServices/ListAllWorkingShifts', {});
        return result.WorkingShifts.map(x => {
            let w = new WorkingShift(this);
            w.id = x.Id;
            w.title = x.Name;
            // let start = `${Math.floor(x.StartTime / 60)}:${x.StartTime % 60}`;
            // let end = `${Math.floor(x.EndTime / 60)}:${x.EndTime % 60}`;
            // w.title = `${x.Name} (${moment(start, 'HH:mm').format('HH:mm')} تا ${moment(end, 'HH:mm').format('HH:mm')})`;
            return w;
        });
    }
}

export class WorkingShift extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}